class Ditto {
  widgets = {}

  get fields() {
    return Object.keys(this.widgets)
  }

  registeWidget(name, opts = {}) {
    if (!this.widgets[name]) {
      this.widgets[name] = {}
    }
    this.widgets[name].render = opts.render || this.widgets[name].render
    this.widgets[name].validation =
      opts.validation || this.widgets[name].validation

    this.widgets[name].config = opts.config || this.widgets[name].config
    this.widgets[name].spec = opts.spec || this.widgets[name].spec
    this.widgets[name].filterSpec =
      opts.filterSpec || this.widgets[name].filterSpec
    this.widgets[name].preProcess =
      opts.preProcess || this.widgets[name].preProcess
    this.widgets[name].transformer =
      opts.transformer || this.widgets[name].transformer
    return this.widgets[name]
  }

  render(name) {
    if (!name) {
      return null
    }

    return this.widgets[name] && this.widgets[name].render

    // return (this.widgets[name] || this.widgets.default).render
  }

  spec(name, opts) {
    return (
      this.widgets[name] &&
      this.widgets[name].spec &&
      this.widgets[name].spec(opts)
    )
  }

  config(name) {
    return this.widgets[name] && this.widgets[name].config
  }

  // validation(name) {
  //   return (
  //     this.widgets[name] && this.widgets[name].validation
  //     // &&
  //     // this.widgets[name].validation(this.widgets[name].spec)
  //   )
  // }

  validation(name, opts, fields, data, refConditonFields) {
    return (
      this.widgets[name] &&
      this.widgets[name].validation &&
      this.widgets[name].validation(opts || {}, fields, data, refConditonFields)
    )
  }

  filter(name) {
    return (this.widgets[name] && this.widgets[name].filterSpec) || []
  }

  transform(name, origin, defs, rowData, fields, hooks) {
    try {
      let trans = this.widgets[name] && this.widgets[name].transformer
      trans =
        trans || (this.widgets.default && this.widgets.default.transformer)
      return trans && trans(origin, defs, rowData, fields, hooks)
    } catch {
      return {
        value: null,
        origin,
        rowData,
        fields,
        defs,
        hooks,
      }
    }
  }

  preProcess(name) {
    return this.widgets[name] && this.widgets[name].preProcess
  }
}

export default Ditto
